<template>
    <div class="footer">
        <!-- 公司理念 -->
        <div class="flex-col align-center env">
            <div class="img-container" @click="goCore">
                <div class="image-overlay">
                    <img src="/static/img/index/env.jpg" class="env-pic"/>
                </div>
            </div>
        </div>

        <!-- 底部导航 -->
        <div class="footer-nav">
            <div class="flex-center">
                <img class="footer-logo" src="/static/img/logo.png"/>
            </div>
            <div class="flex-col align-center footer-menu txt">
                <router-link tag="div" to="/home/index" class="menu-item flex-between-center">
                    {{$t("menu.l1")}}
                    <div class="drop-down-box flex-row justify-end align-center" @click="dropdown(1)">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 1 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </router-link>

                <div class="menu-item flex-between-center" @click="dropdown(2)">
                    {{$t("menu.l2")}}
                    <div class="drop-down-box flex-row justify-end align-center">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 2 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </div>
                <div v-if="menuIndex == 2" class="sub-menu">
                    <div class="sub-menu-item flex-row align-center" @click="goAbout('#brand-intro')">{{lang == 'zh' ? '品牌简介' : 'Brand Introduction'}}</div>
                    <div class="sub-menu-item flex-row align-center" @click="goAbout('#brand-concept')">{{lang == 'zh' ? '品牌理念' : 'Brand Concept'}}</div>
                    <!-- <div class="sub-menu-item flex-row align-center" @click="goAbout('#enterprise-news')">{{lang == 'zh' ? '企业动态' : 'Company News'}}</div> -->
                </div>

                <div class="menu-item flex-between-center">
                    <router-link tag="div" to="/home/yulin/0">{{$t("menu.l3")}}</router-link>
                    <div class="drop-down-box flex-row justify-end align-center" @click="dropdown(3)">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 3 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </div>
                <div v-if="menuIndex == 3" class="sub-menu">
                    <div class="sub-menu-item flex-row align-center" v-for="(item, index) in scenes" :key="index" @click="goScene(index)">
                        {{lang == 'zh' ? item.zh : item.en}}
                    </div>
                </div>

                <div class="menu-item flex-between-center">
                    <router-link tag="div" to="/home/product">{{$t("menu.l4")}}</router-link>
                    <div class="drop-down-box flex-row justify-end align-center" @click="dropdown(4)">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 4 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </div>
                <div v-if="menuIndex == 4" class="sub-menu">
                    <div class="sub-menu-item flex-row align-center" v-for="(item, index) in spaces" :key="index" @click="goSpace(index)">
                        {{lang == 'zh' ? item.zh : item.en}}
                    </div>
                </div>
                
                <!-- <div class="menu-item flex-between-center">
                    <router-link tag="div" to="/home/core">{{$t("menu.l5")}}</router-link>
                    <div class="drop-down-box flex-row justify-end align-center" @click="dropdown(5)">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 5 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </div> -->

                <div class="menu-item flex-between-center">
                    <router-link tag="div" to="/home/news">{{$t("menu.l6")}}</router-link>
                    <div class="drop-down-box flex-row justify-end align-center" @click="dropdown(6)">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 6 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </div>

                <div class="menu-item flex-between-center">
                    <router-link tag="div" to="/home/join">{{$t("menu.l7")}}</router-link>
                    <div class="drop-down-box flex-row justify-end align-center" @click="dropdown(7)">
                        <img src="/static/img/icon_arrow_right_white.png" :class="menuIndex == 7 ? 'drop-down' : 'arrow-right'"/>
                    </div>
                </div>

                <div class="menu-item flex-row align-center">{{$t("ContactUs.p3")}}</div>
                <div class="menu-item flex-row align-center">{{$t("ContactUs.p4")}}</div>
            </div>

            <div v-if="lang == 'zh'" class="flex-col align-center copyright">
                <p style="margin: 10px 0;">COPYRIGHT @ 2026 版权所有</p>
                <p>江苏林德曼新材料科技有限公司</p>
                <a class="beian" href="https://beian.miit.gov.cn" target="_blank">苏ICP备2024076619号</a>
            </div>
            <div v-else class="flex-col justify-center align-center copyright">
                <p style="margin: 10px 0;">COPYRIGHT @ 2026 ALL RESERVED Copyright</p>
                <p>Jiangsu Lindeman Tech Co., Ltd.</p>
                <a class="beian" href="https://beian.miit.gov.cn" target="_blank">苏ICP备2024076619号</a>
            </div>
        </div>
    </div>
</template>

<script>
    import pubsub from 'pubsub-js'

    export default {
        data() {
            return {
                lang: localStorage.getItem('lindemanLocaleLanguage') ? localStorage.getItem('lindemanLocaleLanguage') : 'zh',

                menuIndex: 0,

                scenes: [
                    {zh: '房车应用场景', en: 'RV Application Scenarios'},
                    {zh: '家居定制场景', en: 'Home Customization Scenarios'}
                ],

                spaces: [
                    {zh: '智慧厨房', en: 'Smart Kitchen'},
                    {zh: '智慧餐厅', en: 'Smart Restaurant'},
                    {zh: '智慧客厅', en: 'Smart Living Room'},
                    {zh: '智慧儿童房', en: 'Smart Children Room'},
                    {zh: '智慧衣帽间', en: 'Smart Wardrobe'},
                    {zh: '智慧卧室', en: 'Smart Bedroom'},
                    {zh: '智慧书房', en: 'Smart Study Room'},
                    {zh: '智慧玄关', en: 'Smart Entrance'},
                    {zh: '智慧卫浴', en: 'Smart Bathroom'},
                    {zh: '智慧洗衣房', en: 'Smart Laundry Room'}
                ]
            }
        },

        mounted() {
            // 订阅消息
            this.pid = pubsub.subscribe('lindemanLocaleLanguage', (msgName, data) => { this.lang = data }) 
            this.menuIndex = 0
        },

        beforeDestroy() {
            pubsub.unsubscribe(this.pid)
        },

        watch: {
            $route(to, from) {
                // 检测到路由切换后，折叠底部导航的子菜单
                this.menuIndex = 0
            }
        },

        methods: {
            dropdown(menuIndex) {
                // 核心优势、新闻资讯、加入我们没有子菜单，直接跳转
                if(menuIndex == 1){
                    this.goIndex()
                }else if(menuIndex == 5){
                    this.goCore()
                }else if(menuIndex == 6){
                    this.goNews()
                }else if(menuIndex == 7){
                    this.goJoin()
                }else{
                    this.menuIndex = this.menuIndex == menuIndex ? 0 : menuIndex
                }
            },

            // 跳转首页
            goIndex(){
                this.$router.push({
                    path: '/home/index',
                    query: {
                        key: Math.random()
                    }
                })
            },
            // 跳转核心优势详情页
            goCore(){
                this.$router.push({
                    path: '/home/core',
                    query: {
                        key: Math.random()
                    }
                })
            },

            // 跳转关于我们详情页
            goAbout(hash){
                this.$router.push({
                    path: '/home/about',
                    hash: hash,
                    query: {
                        key: Math.random()
                    }
                }).then(() => {
                    // 确保路由跳转完成后再滚动
                    this.activeMenu = null
                }).catch(err => {
                    console.error('Navigation error:', err)
                    this.activeMenu = null
                })
            },

            // 跳转裕林科技板应用场景
            goScene(index){
                this.$router.push({
                    path: '/home/yulin/' + index,
                    query: {
                        key: Math.random()
                    }
                })
                this.activeMenu = null
            },

            // 跳转产品中心十大空间
            goSpace(index){
                this.$router.push({
                    path: '/home/product',
                    query: {
                        spaceIndex: index,
                        key: Math.random()
                    }
                })
                this.activeMenu = null
            },
            
            // 跳转新闻资讯详情页
            goNews(){
                this.$router.push({
                    path: '/home/news',
                    query: {
                        key: Math.random()
                    }
                })
            },

            // 跳转加入我们详情页
            goJoin(){
                this.$router.push({
                    path: '/home/join',
                    query: {
                        key: Math.random()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../static/css/mobile/footer.scss';
</style>




// WEBPACK FOOTER //
// src/components/mobile/Footer.vue